/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Group_Admin_DescriptionInputs */

const en_users_form_group_admin_description = /** @type {(inputs: Users_Form_Group_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrative users with access to manage the entire platform.`)
};

const pt_br2_users_form_group_admin_description = /** @type {(inputs: Users_Form_Group_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuários administrativos com acesso para gerenciar toda a plataforma.`)
};

/**
* | output |
* | --- |
* | "Administrative users with access to manage the entire platform." |
*
* @param {Users_Form_Group_Admin_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_admin_description = /** @type {((inputs?: Users_Form_Group_Admin_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Admin_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_admin_description(inputs)
	return pt_br2_users_form_group_admin_description(inputs)
});